import { useEffect, useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";

function Home() {
  const [patients, setPatients] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchPatients();
  }, [search]);

  const fetchPatients = async () => {
    try {
      const res = await api.get(`/api/patients?search=${search}`);
      setPatients(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <div className="max-w-3xl mx-auto px-4 py-4 sm:px-6 sm:py-6">
        {/* Page Title */}
        <h1 className="text-2xl font-semibold mb-4">
          Patients
        </h1>

        {/* Search Box */}
        <input
          type="text"
          placeholder="Search by name or phone"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="
            w-full
            h-11
            px-4
            mb-6
            border
            rounded-lg
            text-base
            focus:outline-none
            focus:ring
          "
        />

        {/* Patient List */}
        <div className="space-y-3">
  {patients.map((p) => (
    <div
      key={p.id}
      onClick={() => navigate(`/patients/${p.id}`)}
      className="
        bg-white
        rounded-xl
        shadow-sm
        cursor-pointer
        active:bg-gray-100
        transition
        flex
        items-center
        gap-4
        p-4
      "
    >
      {/* Patient ID Badge */}
      <div className="
        min-w-[56px]
        h-14
        rounded-lg
        bg-blue-600
        text-white
        flex
        items-center
        justify-center
        font-bold
        text-lg
      ">
        {p.id}
      </div>

      {/* Patient Info */}
      <div className="flex-1">
        <div className="text-base font-semibold text-gray-900">
          {p.name}
        </div>

        <div className="text-sm text-gray-600 mt-1">
          📞 {p.phone}
        </div>
      </div>

      {/* Chevron */}
      <div className="text-gray-400 text-xl">
        ›
      </div>
    </div>
  ))}

  {patients.length === 0 && (
    <div className="text-gray-500 text-sm text-center py-8">
      No patients found.
    </div>
  )}
</div>

      </div>
    </div>
  );
}

export default Home;
